import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { additionalBannersSelector } from 'store/state/domainData/selectors/bannersByDocId';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { noop } from 'lodash';
import { createExposeBannerIntersection, getAds, getBanner } from './helpers';
import withEvents from 'analytics/withEvents';
import { useRoute } from 'config/routes';
import { IAd, ProjectAdBannerSourceProps, ScreenType } from './types';

const AdditionalAdBannerSource: React.FC<ProjectAdBannerSourceProps> = props => {
  const { children, banners, onBannerExpose, source } = props;
  const { router } = useRoute();
  const constructImageURI = useImageUrlBuilder();
  const screenType = useScreenBreakpoint() === 1 ? ScreenType.Mobile : ScreenType.Desktop;
  const [ term ] = source.split('#');
  const onBannerIntersection = useCallback(createExposeBannerIntersection(onBannerExpose), [ term ]);

  const ads = useMemo(
    () => getAds(banners, router, constructImageURI, screenType),
    [ banners, screenType, router ]
  );

  return <>{children(getBanner(ads, source, onBannerIntersection))}</>;
};

AdditionalAdBannerSource.defaultProps = {
  onBannerExpose: noop,
  source: 'uniq#source',
};

const AdditionalAdBannerSourceWithEvents = withEvents<ProjectAdBannerSourceProps>(sendEvent => ({
  onBannerExpose({ id, isExternalLink, link }: IAd, index: number) {
    sendEvent('banner_exposed', 'banner', {
      event: {
        banner_id: id,
        banner_is_external: isExternalLink,
        banner_url: link,
        banner_index: index,
      },
    });
  },
}))(AdditionalAdBannerSource);


const mapStateToProps = (state: State) => ({
  banners: additionalBannersSelector(state),
});

export default connect(mapStateToProps)(AdditionalAdBannerSourceWithEvents);
